var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex flex-row justify-between"},[_c('h4',{staticClass:"medium"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("action")],2),_c('div',{staticClass:"drive-card flex"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }